<template>
    <div class="header-box" @click="go">
        <p>洛阳市儿童救助保护综合服务平台</p>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {},
    methods: {
        go() {
            this.$router.push({ name: 'index' });
        }
    },
    components: {}
};
</script>
<style scoped lang="scss">
.header-box {
    position: absolute;
    left: 40px;
    text-align: center;
    padding: 20px 0 10px 0;
    background: url(../assets/img/title.png) no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
    height: 60px;
    right: 50px;
    top: 20px;
    p {
        color: #ffffff;
        font-size: 34px;
        font-weight: bold;
    }
}
</style>
